import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataProductsPage } from '../../../../redux/actions/pages/products';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { EDIT_ORDER_GET, CHANGE_ORDER_ITEM_STATUS, DELIVER_ORDER, IMAGE_ADDRESS } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataEditOrderPage } from '../../../../redux/actions/pages/orders/edit'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useParams } from "react-router-dom";


const EditOrder = () => {

	const dispatch = useDispatch();

    const { uniqueCode } = useParams();


	const { token } = useSelector(state => state.login);
    const { content } = useSelector(state => state.editOrder);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    console.log('arash');
    console.log(content);
    

    useEffect(() => {
        // dispatch(handleChangeDataOrdersPage('inputUniqueCode', ''));
        // dispatch(handleChangeDataOrdersPage('inputUserName', ''));
        // dispatch(handleChangeDataOrdersPage('inputMobile', ''));
        apiOrderDetails();
        // eslint-disable-next-line
    }, [uniqueCode]);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const apiOrderDetails = (event) => {
        if(event !== undefined)
            event.preventDefault();

        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: EDIT_ORDER_GET + "/" + uniqueCode,
                method: 'get',
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                    dispatch(handleChangeDataEditOrderPage('content', res.content));
                },
            });
        }

    };


    const handleClickSearchBtn = () => {
        setIsSearchVisible(! isSearchVisible);
        setIsHeadingElementsVisible(false);
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataEditOrderPage(name, value));
    };


    const apiChangeStatus = (item, key, index) => {
        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: CHANGE_ORDER_ITEM_STATUS,
                method: 'post',
                data: {item: item},
                token: token,
                successMessage: "تغییر وضعیت با موفقیت انجام شد",
                onSuccess: (res) => {
                    let newContent = content;
                    newContent.consignments[key].products[index].status = res.newStatus;
                    newContent.consignments[key].products[index].statusTxt = res.newStatusTxt;
                    newContent.consignments[key].products[index].statusTag = res.newStatusTag;
                    newContent.consignments[key].status = res.newConsignmentStatus;
                    newContent.consignments[key].statusTxt = res.newConsignmentStatusTxt;
                    dispatch(handleChangeDataEditOrderPage('content', newContent));
                },
            });
        }
    };


    const apiDeliver = (shippingType) => {
        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: `${DELIVER_ORDER}/${content.id}/${shippingType}`,
                method: 'get',
                token: token,
                successMessage: "محموله مورد نظر به مشتری تحویل شد",
                onSuccess: (res) => {
                    let newContent = content;
                    newContent.consignments.map((consignment, key) => {
                        if(consignment.shippingType === shippingType) {
                            consignment.status = 'delivered';
                            consignment.statusTxt = 'تحویل شده';
                            consignment.products.map((product, productKey) => {
                                product.status = 'delivered';
                                product.statusTag = 'tag-success';
                                product.statusTxt = 'تحویل شده';
                            });
                        }
                    });
                    dispatch(handleChangeDataEditOrderPage('content', newContent));
                },
            });
        }
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <div className="row">
                        <div className="col-xs-12">
                            {content.consignments && content.consignments.map((consignment, key) => (
                                <div className="card" style={{ minHeight: "unset" }} key={key}>
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            محموله {key + 1} از {content.consignments.length}
                                        </h4>
                                        <a className="heading-elements-toggle">
                                            <i className="icon-ellipsis font-medium-3"></i>
                                        </a>
                                        <div className="heading-elements">
                                            <ul className="list-inline mb-0">
                                                <li>
                                                    <a data-action="collapse">
                                                        <i className="icon-minus4"></i>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a data-action="expand">
                                                        <i className="icon-expand2"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="card-body collapse in">
                                        <div id="invoice-customer-details" className="row pt-2 px-2">
                                            <div className="col-md-6 col-sm-12 text-xs-center text-md-left">
                                                <p>
                                                    <span className="text-muted">نوع کالا:</span>{" "}
                                                    {consignment.shippingTypeTxt}
                                                </p>
                                                <p>
                                                    <span className="text-muted">هزینه ارسال:</span>{" "}
                                                    {Number(consignment.price / 10).toLocaleString()}
                                                </p>
                                                <p>
                                                    <span className="text-muted">مبلغ مرسوله:</span>{" "}
                                                    {Number(consignment.consignmentPrice / 10).toLocaleString()}
                                                </p>
                                                <p>
                                                    {consignment.status === "shipped" && (
                                                        <Link
                                                            onClick={() => apiDeliver(consignment.shippingType)}
                                                            to={`#`}
                                                            >
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-min-width mr-1 mb-1"
                                                            >
                                                                تحویل به مشتری
                                                            </button>
                                                        </Link>
                                                    )}
                                                </p>
                                            </div>

                                    <div className="col-md-6 col-sm-12 text-xs-center text-md-right">
                                        <p>
                                            <span className="text-muted">کد پیگیری مرسوله:</span>{" "}
                                            {consignment.uniqueCode}
                                        </p>
                                        <p>
                                            <span className="text-muted">زمان تحویل :</span>{" "}
                                            {consignment.deliveryDate} بازه {consignment.deliveryTime}
                                        </p>
                                        <p>
                                            <span className="text-muted">وضعیت :</span>{" "}
                                            {consignment.statusTxt}
                                        </p>
                                    </div>
                                </div>

                                <div id="invoice-items-details" className="pt-2">
                                    <div className="row">
                                        <div className="table-responsive col-sm-12">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>تصویر</th>
                                                        <th>محصول</th>
                                                        <th className="text-xs-right">تعداد</th>
                                                        <th className="text-xs-right">قیمت (تومان)</th>
                                                        <th className="text-xs-right">تخفیف</th>
                                                        <th className="text-xs-right">جمع کل (تومان)</th>
                                                        <th className="text-xs-right">وضعیت</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {consignment.products.map((product, index) => (
                                                        <tr key={index}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>
                                                                <LazyLoadImage
                                                                src={`${IMAGE_ADDRESS}/products/${product.image}`}
                                                                width="60"
                                                                alt={product.title}
                                                                />
                                                            </td>
                                                            <td>
                                                                <p>{product.title}</p>
                                                            </td>
                                                            <td className="text-xs-right">
                                                                {Number(product.qty)}
                                                            </td>
                                                            <td className="text-xs-right">
                                                                {Number((product.oldPrice > '0' ? product.oldPrice : product.unitPrice) / 10).toLocaleString()}
                                                            </td>
                                                            <td className="text-xs-right pink">
                                                                {product.oldPrice > product.unitPrice
                                                                    ? Number(
                                                                    (product.oldPrice - product.unitPrice) / 10
                                                                    ).toLocaleString()
                                                                    : "0"}
                                                                </td>
                                                                <td className="text-xs-right">
                                                                    {Number(
                                                                        (product.unitPrice * product.qty) / 10
                                                                        ).toLocaleString()}
                                                                    </td>
                                                                    <td className="text-xs-right">
                                                                        <span
                                                                            onClick={() => apiChangeStatus(product.itemId, key, index)}
                                                                            className={`tag tag-default ${product.statusTag} tag-status`}
                                                                            data-item={product.itemId}
                                                                            style={{
                                                                            cursor:
                                                                            consignment.status === "pending" ||
                                                                            consignment.status === "shipped"
                                                                            ? "pointer"
                                                                            : "default",
                                                                    }}
                                                                    >
                                                                    {product.statusTxt}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>





                </div>
            </div>
        </div>
    );
}

export default EditOrder;